export const i18Path = 'myData.inventory.addInventoryModal';
